import auth from "./Auth";

export namespace Authentication {
    export const Auth = auth;
}
